import React from "react";
import { StatusPill } from "@/components/StatusPill";
import { MapPin, ChevronRight, Plus } from "lucide-react";

export function DemoJobs({ job, onOpenJob, onNewJob }) {
  return (
    <div className="mx-auto w-full max-w-md md:max-w-2xl px-4 pb-40 pt-4 sm:px-8" data-testid="demo-jobs">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-bold">Jobs</h1>
          <p className="text-sm text-muted-foreground">1 total</p>
        </div>
        <button onClick={onNewJob} data-testid="demo-new-job" className="hidden items-center gap-1 rounded-lg bg-emerald-500 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-600 md:flex">
          <Plus className="h-4 w-4" /> New Job
        </button>
      </div>

      <div className="mt-4 space-y-2.5">
        <button
          onClick={onOpenJob}
          data-testid="demo-open-concrete-job"
          className="card-elevated flex w-full items-center gap-3 rounded-2xl border border-border bg-card p-4 text-left transition-transform active:scale-[0.99]"
        >
          <div className="min-w-0 flex-1">
            <span className="block truncate font-semibold">{job.name}</span>
            <div className="mt-0.5 flex items-center gap-1 text-xs text-muted-foreground">
              <MapPin className="h-3 w-3" /> <span className="truncate">{job.location}</span>
            </div>
            <div className="mt-2 flex items-center gap-2">
              <StatusPill status="sent" />
              <span className="text-xs text-muted-foreground">3 items</span>
            </div>
            <div className="mt-2 flex items-center gap-2">
              <div className="flex h-1.5 flex-1 overflow-hidden rounded-full bg-muted">
                <div className="h-full bg-emerald-500" style={{ width: "33%" }} />
              </div>
              <span className="text-xs font-bold text-emerald-600">33%</span>
            </div>
          </div>
          <ChevronRight className="h-5 w-5 shrink-0 text-muted-foreground/60" />
        </button>

        <button
          onClick={onNewJob}
          data-testid="demo-new-job-card"
          className="flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-emerald-500/60 py-5 text-sm font-semibold text-emerald-500 transition-transform active:scale-[0.99] hover:bg-emerald-500/10"
        >
          <Plus className="h-5 w-5" /> Create your own job
        </button>
      </div>

      {/* FAB mobile */}
      <button
        onClick={onNewJob}
        data-testid="demo-fab-new-job"
        className="fixed bottom-24 right-5 z-30 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500 text-white shadow-lg shadow-emerald-500/30 md:hidden"
      >
        <Plus className="h-7 w-7" />
      </button>
    </div>
  );
}
